import { Component, forwardRef, Input, Optional, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NfpBaseInputControlComponent } from '../nfp-base-input-ctrl/nfp-base-input-ctrl.component';

@Component({
  selector: 'nfp-dropdown-question',
  templateUrl: './nfp-dropdown-question.component.html',
  styleUrls: ['./nfp-dropdown-question.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'row mb-1' },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => NfpDropdownQuestionComponent),
    }
  ]
})
export class NfpDropdownQuestionComponent extends NfpBaseInputControlComponent {
  @Input() id: string;
  @Input() name: string;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;

  constructor() {
    super();
  }

  onDropdownChanged(evt: any) {
    this.value = evt?.value ?? '';
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
